__turbopack_context__.v({
  "itemLink": "-qp4Xq_itemLink",
  "list": "-qp4Xq_list",
  "listItem": "-qp4Xq_listItem",
});
